export default class CopyUrl {
    constructor() {
        this.linkCopy = document.querySelectorAll('[data-copyurl]');
        this.ready();
    }

    ready() {
        this.linkCopy.forEach((item) => {
            let url = item.dataset.copyurl;
            let label = item.querySelector('.copy-label');

            item.addEventListener('click', () => {
                navigator.clipboard.writeText(url);
                label.classList.add('active');

                setTimeout(() => {
                    label.classList.remove('active');
                }, 2500);
            });
        });
    }
}
if (document.querySelectorAll('[data-copyurl]')) {
    try {
        new CopyUrl();
    } catch (e) {}
}
